core-tag {
  display: inline-flex;
}

.core-tag {
  display: inline-flex;
  align-items: center;
  gap: var(--number-spacing-4xsmall);
}

/* Size */
.core-tag.tag-size--small {
  border-radius: var(--number-radius-xsmall);
  padding: var(--number-spacing-4xsmall) var(--number-spacing-3xsmall);
}
.core-tag.tag-size--small.tag-with-icon {
  padding: var(--number-spacing-4xsmall) var(--number-spacing-3xsmall) var(--number-spacing-4xsmall) var(--number-spacing-4xsmall);
}

.core-tag.tag-size--medium {
  border-radius: var(--number-radius-small);
  padding: var(--number-spacing-2xsmall) var(--number-spacing-xsmall);
}
.core-tag.tag-size--medium.tag-with-icon {
  padding: var(--number-spacing-2xsmall) var(--number-spacing-xsmall) var(--number-spacing-2xsmall) var(--number-spacing-2xsmall);
}

/* Color */
.core-tag.tag-color--brand {
  background-color: var(--color-brand-background);
  color: var(--color-brand-content);
}
.core-tag.tag-color--status-success {
  background-color: var(--color-status-background-success);
  color: var(--color-status-content-success);
}
.core-tag.tag-color--status-warning {
  background-color: var(--color-status-background-warning);
  color: var(--color-status-content-warning);
}
.core-tag.tag-color--status-error {
  background-color: var(--color-status-background-error);
  color: var(--color-status-content-error);
}
.core-tag.tag-color--status-information {
  background-color: var(--color-status-background-information);
  color: var(--color-status-content-information);
}
.core-tag.tag-color--neutral {
  background-color: var(--color-neutral-background-soft);
  color: var(--color-neutral-content-medium);
}
.core-tag.tag-color--additional-color-1 {
  background-color: var(--color-additional-background-color1);
  color: var(--color-additional-content-color1);
}
.core-tag.tag-color--additional-color-2 {
  background-color: var(--color-additional-background-color2);
  color: var(--color-additional-content-color2);
}
.core-tag.tag-color--additional-color-3 {
  background-color: var(--color-additional-background-color3);
  color: var(--color-additional-content-color3);
}
.core-tag.tag-color--additional-color-4 {
  background-color: var(--color-additional-background-color4);
  color: var(--color-additional-content-color4);
}
